import styled from "styled-components";
import PropTypes from "prop-types";

import { OverflowMenuMobile } from "../OverflowMenuMobile";
import { OverflowMenuDesktop } from "../OverflowMenuDesktop";
import { openMobileMenuStyles } from "../OverflowMenuMobile/styles";

const Wrapper = styled.div`
    position: relative;

    ${OverflowMenuDesktop} {
        /* toggle menu */
        display: ${({ open }) => (open ? "block" : "none")};

        /* hide menu on smaller screens */
        @media (max-width: 75rem) {
            display: none;
        }
    }

    ${OverflowMenuMobile} {
        display: none;

        @media (max-width: 75rem) {
            /* toggle menu  */
            ${({ open }) => open && openMobileMenuStyles}
        }
    }
`;

Wrapper.propTypes = {
    open: PropTypes.bool
};

export { Wrapper };
